import React from "react"
import SchemaStars from "../components/schemastars"

export default class ProfilesCards extends React.Component  
{
    constructor(props)    
    {
        super(props)

        this.profiles = []          
        if (this.props.profiles.length > 0 ) this.profiles = this.props.profiles        
    
        this.env = this.props.env     
        this.requestImageFile = require.context('../images', true, /.png$/)  
        this.code = this.props.code 
        this.place = this.props.place        

        //this.profiles.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)) 

        this.showPhone = false

        if( this.code === 'dumpster' || 
            this.code === 'comercial-trash-service' || 
            this.code === '10-yard-dumpster' ||
            this.code === '20-yard-dumpster' ||
            this.code === 'roll-off-dumpsters' ||
            this.code === 'construction-dumpster' ) this.showPhone = true        
    }    

    addImage = (image, name) =>
    {
        const defaultimg = this.env.site === 'dumpster' ? '/default-dumpster-clp.png' : '/default-demolition-clp.png'
        
        if(image.path)
        {
            return(
                <div className="images" itemprop="image" itemscope="itemscope" itemtype="http://schema.org/ImageObject"> 
                    <img itemprop="url" src={image.path} alt={name+' logo'}/>
                </div>                   
            )
        }

        return (
            <div className="images" itemprop="image" itemscope="itemscope" itemtype="http://schema.org/ImageObject"> 
                <img itemprop="url" src={defaultimg} alt={this.env.site}/>                               
            </div>                   
        )
    }

    addPhone = (phone) =>
    {           
        if(phone !== '')
        {
            return(
                <a href={'tel://'+phone}><span itemprop="telephone">{phone}</span></a>
            )
        }

        return <></>
    }

    button = (id) =>
    {
        if( this.code === 'dumpster' || 
            this.code === 'comercial-trash-service' || 
            this.code === '10-yard-dumpster' ||
            this.code === '20-yard-dumpster' ||
            this.code === 'roll-off-dumpsters' ||
            this.code === 'construction-dumpster' ) return <></>
        
        return(
            <div className="actions">                                            
                <a className="request-quote fire-quote" href="#top" data-proid={id} data-toggle="modal" data-target="#quote-steps-modal">Request a Quote</a>
            </div>
        )
    }

    stripHtml = (html) =>
    {
        return html.replace(/(<([^>]+)>)/gi, "").replace('&nbsp;', '')
    }
    
    render()
    {
        return (

            <div className={"items-grid prof "+this.props.env.site}>
                <div className="container">
                    <div className="row">
                    {
                        this.profiles.map((profile, index) =>
                        {                                                                                                              
                            const pro = profile                            
                            const descs = pro.descriptions.length > 0 ? pro.descriptions[0] : []
                            const unpaid = profile.unpaid
                            let description = pro.description                             

                            descs.map(desc =>
                            {
                                let fixedcode

                                switch (this.code) 
                                {
                                    case 'dumpster':
                                        fixedcode = 'dumpster-rental'
                                        break;
                                
                                    default:
                                        fixedcode = this.code
                                        break;
                                }
                                
                                if(desc.kg === undefined) return false
                                if(desc.v === undefined) return false                                
                                if(desc.kg === fixedcode && desc.v != null) description = desc.v  
                                
                                return true
                            })                            
                                                        
                            const name = pro.name
                            const phone = pro.phone
                            
                            description = this.stripHtml(description)

                            let address = `Serving ${this.place.name}` 
                            
                            if(!profile.hide_address)
                            {
                                address = pro.address +', '+ pro.address_extras
                                if(address === ', ') address = ''                            
                                if(address === '') address = this.place.name
                            }                            

                            let image =
                            {
                                path: '',
                                alt: ''
                            }
                            
                            if(pro.logo !== null)
                            {                                
                                image =
                                {
                                    path: pro.logo.path,
                                    alt: pro.logo.alt
                                }
                            }      
                            
                            const rates = []

                            profile.reviews.map(review =>
                            {
                                rates.push(review.stars)
                                return true
                            })

                            return(

                                <div data-proid={pro.id} itemscope="itemscope" itemtype="https://schema.org/LocalBusiness" key={index} className="card-pro-view col-12 col-md-6 col-lg-4 mb-5">
                                    <div data-id={pro.id} className="item">                                    
                                        {this.addImage(image, name)}
                                        <h2 className="title"><a href={'/'+profile.url}><span itemprop="name">{name}</span></a></h2>
                                        <SchemaStars reviews calculate={rates} url={'/'+profile.url}/>
                                        <div className="address">
                                            <span itemprop="address">{address}</span>
                                        </div>
                                        {!unpaid && <div className="phone">{this.addPhone(phone)}</div>}
                                        <div className="text">
                                            <p itemprop="description">{description}</p>
                                        </div>                     
                                        {this.showPhone && !unpaid &&
                                        <div className="call">
                                            <p>Call for the Best Price</p>
                                            <a href={'tel://'+phone}><span itemprop="telephone">{phone}</span></a>
                                        </div>}
                                        {this.button(pro.id)}                                 
                                    </div>
                                </div>  

                            )
                        })
                    }
                    </div>
                </div>
            </div>
        )
    }
}